var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
define(["require", "exports", "lit", "lit/decorators.js", "client/resourceinfo"], function (require, exports, lit_1, decorators_js_1, resourceinfo_1) {
    "use strict";
    var _a, _b;
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.InsightRenderedItems = void 0;
    resourceinfo_1 = __importDefault(resourceinfo_1);
    /**
     * @element insight-rendered-items
     */
    class InsightRenderedItems extends lit_1.LitElement {
        connectedCallback() {
            const _super = Object.create(null, {
                connectedCallback: { get: () => super.connectedCallback }
            });
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b;
                _super.connectedCallback.call(this);
                try {
                    const baseUrl = resourceinfo_1.default.scriptLocation;
                    const [faRes, fa5Res] = yield Promise.all([
                        fetch(`${baseUrl}../css/font-awesome.min.css`),
                        fetch(`${baseUrl}../css/font-awesome-5.min.css`),
                    ]);
                    const [fa4Css, fa5Css] = yield Promise.all([
                        faRes.text(),
                        fa5Res.text(),
                    ]);
                    const styleEl = document.createElement('style');
                    styleEl.textContent = `${fa4Css}\n${fa5Css}`;
                    (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.prepend(styleEl);
                    if (this.parentStyles) {
                        const parentStyleEl = document.createElement('style');
                        parentStyleEl.textContent = this.parentStyles.cssText;
                        (_b = this.shadowRoot) === null || _b === void 0 ? void 0 : _b.prepend(parentStyleEl);
                    }
                    this.requestUpdate();
                }
                catch (err) {
                    console.error('Failed to load FontAwesome CSS:', err);
                }
            });
        }
        render() {
            return (0, lit_1.html) `
      <div class="content">${this.object}</div>
    `;
        }
    }
    exports.InsightRenderedItems = InsightRenderedItems;
    InsightRenderedItems.styles = (0, lit_1.css) `
    :host {
      display: block;
    }
  `;
    __decorate([
        (0, decorators_js_1.property)({ type: Object }),
        __metadata("design:type", Object)
    ], InsightRenderedItems.prototype, "object", void 0);
    __decorate([
        (0, decorators_js_1.property)({ type: Object }),
        (0, decorators_js_1.property)({ type: Object }),
        __metadata("design:type", typeof (_b = typeof lit_1.CSSResult !== "undefined" && lit_1.CSSResult) === "function" ? _b : Object)
    ], InsightRenderedItems.prototype, "parentStyles", void 0);
});
// customElementRegistry.register("insight-rendered-items", InsightRenderedItems);
